import { Component, ViewChild } from '@angular/core';
import { MainService } from '../../service/main.service';
import { ProfileService } from '../../../portal/service/profile.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthenticationService } from '../../../authentication.service';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: '[app-hrms-sidebar]',
  templateUrl: './hrms-sidebar.component.html',
  styleUrls: ['./hrms-sidebar.component.css']
})
export class HrmsSidebarComponent {
  user_id: any;
  imgURL: any;
  erpUser: any;
  accInfo: any;
  userInfo: any = { emp_name: 'Ram Prasad', designation: 'Accountant' }
  // sideBarFlag={'HR-R1':true,'HR-R2':true,'EMB-R3':true,'EBILL-R4':true,'DEVIATION-R5':true,'Completion-R6':true,
  // 'TERM-R7':true,'CODE-VALUE-R8':true,'Vendors-R9':true,'Deduction-R12':true,'Geometry-R13':true,'Budget-R19':true,'Work-R11':true,
  // 'DEFAPPR-R21':true,'Users-R14':true,'undertaking':true,'Roles-R15':true,'EMBHIER-R22':true,'Authorization-R16':true
  // ,'sor-R24':true,"morth-R26":true,"dsr-R25":true}
  sideBarFlag: any =  {

    'HR-R1': true, 'HR-R2': true, 'HR-R3': true, 'HR-R4': true, 'HR-R5': true, 'HR-R6': true, 'HR-R7': true, 'HR-R8': true, 'HR-R9': true, 'HR-R10': true, 'HR-R11': true, 'HR-R12': true,
    'HR-R13': true, 'HR-R14': true, 'HR-R15': true, 'HR-R16': true, 'HR-R17': true, 'HR-R18': true, 'HR-R19': true, 'HR-R20': true, 'HR-R21': true, 'HR-R22': true, 'HR-R23': true, 'HR-R24': true, 'HR-R25': true,
    'HR-R26': true, 'HR-R27': true, 'HR-R28': true, 'HR-R29': true, 'HR-R30': true, 'HR-R31': true, 'HR-R32': true, 'HR-R33': true, 'HR-R34': true, 'HR-R35': true, 'HR-R36': true, 'HR-R37': true, 'HR-R38': true
    , 'HR-R39': true, 'HR-R40': true, 'HR-R41': true, 'HR-R42': true, 'HR-R43': true, 'HR-R44': true, 'HR-R45': true, 'HR-R46': true, 'HR-R47': true, 'HR-R48': true, 'HR-R49': true, 'HR-R50': true, 'HR-R51': true
    , 'HR-R52': true, 'HR-R53': true, 'HR-R54': true, 'HR-R55': true, 'HR-R56': true, 'HR-R57': true, 'HR-R58': true, 'HR-R59': true, 'HR-R60': true, 'HR-R61': true, 'HR-R62': true, 'HR-R63': true, 'HR-R64': true, 'HR-R65': true
    , 'HR-R66': true, 'HR-R67': true, 'HR-R68': true, 'HR-R69': true, 'HR-R70': true, 'HR-R71': true, 'HR-R72': true, 'HR-R73': true, 'HR-R74': true, 'HR-R75': true, 'HR-R76': true, 'HR-R77': true, 'HR-R78': true
    , 'HR-R79': true, 'HR-R80': true, 'HR-R81': true, 'HR-R82': true, 'HR-R83': true, 'HR-R84': true, 'HR-R85': true, 'HR-R86': true, 'HR-R87': true, 'HR-R88': true, 'HR-R89': true, 'HR-R90': true, 'HR-R91': true, 'HR-R92': true,'HR-R97': true

  }
  constructor(private router: Router, public auth: AuthenticationService, private profileService: ProfileService, private sanitizer: DomSanitizer, public mainService: MainService) { }
  hidden = true;
  report_hidden = true;
  dashborad_hidden = true;
  party_hidden = true;
  arr_hidden = true;
  leave_hidden = true;
  payroll_hidden = true;
  setting_hidden = true;
  Field_hidden = true
  CodeValue_hidden = true
  AddNewEmployee = true
  LeaveRule_hidden = true
  SalaryRule_hidden = true
  PayMatrix_hidden = true
  CityGroup_hidden = true
  CCAMatrix_hidden = true
  HRAMatrix_hidden = true
  PBRMatrix_hidden = true
  WFMATRIX_hidden = true
  PayRule_hidden = true
  Budget_hidden = true
  Product_hidden = true
  Activity_hidden = true
  security_hidden = true
  Users_hidden = true
  Role_hidden = true
  Hierarchy_hidden = true
  DataAssingment_hidden = true
  WorkFlow_hidden = true
  AllData_hidden = true
  AttendManagement_hidden = true
  AttandanceRule_hidden = true
  CalendarRule_hidden = true
  BoundaryMap_hidden = true
  ExtraWork_hidden = true
  ExtraWorkPermission_hidden = true
  LateSitting_hidden = true
  ACR_hidden = true
  AnnualConfidentialReport_hidden = true
  Help_hidden = true
  FAQ_hidden = true
  UserManual_hidden = true
  TutorialVideos_hidden = true
  OnlineSupport_hidden = true
  MyInfo_hidden = true
  MarkAttendance_hidden = true
  Notice_hidden = true
  Employee_hidden = true
  SalaryComponent_hidden = true
  Bill_hidden = true
  LPCTRANSFER_hidden = true
  PaySlip_hidden = true
  PensionCont_hidden = true
  PFIT_hidden = true
  SalaryHold_hidden = true
  AnnualSalaryStatement_hidden = true
  VariableAnnualSalaryStatement_hidden = true
  AttendanceReport_hidden = true
  List_hidden = true
  AllEmployee_hidden = true
  EducationInfo_hidden = true
  NomineeInfo_hidden = true
  BankDetail_hidden = true
  LIC_hidden = true
  DependentInfo_hidden = true
  Establish_hidden = true
  VariablePay_hidden = true
  Posting_hidden = true
  Promotion_hidden = true
  Probation_hidden = true
  Complaint_hidden = true

  Enquiry_hidden = true
  Suspension_hidden = true
  Termination_hidden = true
  Retirement_hidden = true
  Death_hidden = true
  Attandance_hidden = true
  Leaves_hidden = true
  LeaveApplication_hidden = true
  LeaveList_hidden = true
  TravelReimbursement_hidden = true
  TourDetail_hidden = true
  TABill_hidden = true

  Arrear_hidden = true
  SalaryBill_hidden = true

  SalaryStartStop_hidden = true
  AnnualIncrement_hidden = true
  Advances_hidden = true
  LeaveEncashment_hidden = true
  Reappoaintment_hidden = true
  Resign_hidden = true
  Transfer_hidden = true

  HRAdministration_hidden = true
  Reimbrusment_hidden = true
  TAReimbrusment_hidden = true
  TAADV_hidden = true
  MedicalAdvance_hidden = true


  @ViewChild('ngSelectElement') ngSelectElement!: NgSelectComponent;
  BONUS_hidden:any = true
  async ngOnInit() {

    this.erpUser = JSON.parse(atob(localStorage.getItem('erpUser') as any));
    this.sideBarFlag['HR-R1'] = !this.erpUser['assigned_component'].includes('HR-R1')
    this.sideBarFlag['HR-R2'] = !this.erpUser['assigned_component'].includes('HR-R2')
    this.sideBarFlag['HR-R3'] = !this.erpUser['assigned_component'].includes('HR-R3')
    this.sideBarFlag['HR-R4'] = !this.erpUser['assigned_component'].includes('HR-R4')
    this.sideBarFlag['HR-R5'] = !this.erpUser['assigned_component'].includes('HR-R5')
    this.sideBarFlag['HR-R6'] = !this.erpUser['assigned_component'].includes('HR-R6')
    this.sideBarFlag['HR-R7'] = !this.erpUser['assigned_component'].includes('HR-R7')
    this.sideBarFlag['HR-R8'] = !this.erpUser['assigned_component'].includes('HR-R8')
    this.sideBarFlag['HR-R9'] = !this.erpUser['assigned_component'].includes('HR-R9')
    this.sideBarFlag['HR-R10'] = !this.erpUser['assigned_component'].includes('HR-R10')
    this.sideBarFlag['HR-R11'] = !this.erpUser['assigned_component'].includes('HR-R11')
    this.sideBarFlag['HR-R12'] = !this.erpUser['assigned_component'].includes('HR-R12')
    this.sideBarFlag['HR-R13'] = !this.erpUser['assigned_component'].includes('HR-R13')
    this.sideBarFlag['HR-R14'] = !this.erpUser['assigned_component'].includes('HR-R14')
    this.sideBarFlag['HR-R15'] = !this.erpUser['assigned_component'].includes('HR-R15')
    this.sideBarFlag['HR-R16'] = !this.erpUser['assigned_component'].includes('HR-R16')
    this.sideBarFlag['HR-R17'] = !this.erpUser['assigned_component'].includes('HR-R17')
    this.sideBarFlag['HR-R18'] = !this.erpUser['assigned_component'].includes('HR-R18')
    this.sideBarFlag['HR-R19'] = !this.erpUser['assigned_component'].includes('HR-R19')
    this.sideBarFlag['HR-R20'] = !this.erpUser['assigned_component'].includes('HR-R20')
    this.sideBarFlag['HR-R21'] = !this.erpUser['assigned_component'].includes('HR-R21')
    this.sideBarFlag['HR-R22'] = !this.erpUser['assigned_component'].includes('HR-R22')
    this.sideBarFlag['HR-R23'] = !this.erpUser['assigned_component'].includes('HR-R23')
    this.sideBarFlag['HR-R24'] = !this.erpUser['assigned_component'].includes('HR-R24')
    this.sideBarFlag['HR-R25'] = !this.erpUser['assigned_component'].includes('HR-R25')
    this.sideBarFlag['HR-R26'] = !this.erpUser['assigned_component'].includes('HR-R26')
    this.sideBarFlag['HR-R27'] = !this.erpUser['assigned_component'].includes('HR-R27')
    this.sideBarFlag['HR-R28'] = !this.erpUser['assigned_component'].includes('HR-R28')
    this.sideBarFlag['HR-R29'] = !this.erpUser['assigned_component'].includes('HR-R29')
    this.sideBarFlag['HR-R30'] = !this.erpUser['assigned_component'].includes('HR-R30')
    this.sideBarFlag['HR-R31'] = !this.erpUser['assigned_component'].includes('HR-R31')
    this.sideBarFlag['HR-R32'] = !this.erpUser['assigned_component'].includes('HR-R32')
    this.sideBarFlag['HR-R33'] = !this.erpUser['assigned_component'].includes('HR-R33')
    this.sideBarFlag['HR-R34'] = !this.erpUser['assigned_component'].includes('HR-R34')
    this.sideBarFlag['HR-R35'] = !this.erpUser['assigned_component'].includes('HR-R35')
    this.sideBarFlag['HR-R36'] = !this.erpUser['assigned_component'].includes('HR-R36')
    this.sideBarFlag['HR-R37'] = !this.erpUser['assigned_component'].includes('HR-R37')
    this.sideBarFlag['HR-R38'] = !this.erpUser['assigned_component'].includes('HR-R38')
    this.sideBarFlag['HR-R39'] = !this.erpUser['assigned_component'].includes('HR-R39')
    this.sideBarFlag['HR-R40'] = !this.erpUser['assigned_component'].includes('HR-R40')
    this.sideBarFlag['HR-R41'] = !this.erpUser['assigned_component'].includes('HR-R41')
    this.sideBarFlag['HR-R42'] = !this.erpUser['assigned_component'].includes('HR-R42')
    this.sideBarFlag['HR-R43'] = !this.erpUser['assigned_component'].includes('HR-R43')
    this.sideBarFlag['HR-R44'] = !this.erpUser['assigned_component'].includes('HR-R44')
    this.sideBarFlag['HR-R45'] = !this.erpUser['assigned_component'].includes('HR-R45')
    this.sideBarFlag['HR-R46'] = !this.erpUser['assigned_component'].includes('HR-R46')
    this.sideBarFlag['HR-R47'] = !this.erpUser['assigned_component'].includes('HR-R47')
    this.sideBarFlag['HR-R48'] = !this.erpUser['assigned_component'].includes('HR-R48')
    this.sideBarFlag['HR-R49'] = !this.erpUser['assigned_component'].includes('HR-R49')
    this.sideBarFlag['HR-R50'] = !this.erpUser['assigned_component'].includes('HR-R50')
    this.sideBarFlag['HR-R51'] = !this.erpUser['assigned_component'].includes('HR-R51')
    this.sideBarFlag['HR-R52'] = !this.erpUser['assigned_component'].includes('HR-R52')
    this.sideBarFlag['HR-R53'] = !this.erpUser['assigned_component'].includes('HR-R53')
    this.sideBarFlag['HR-R54'] = !this.erpUser['assigned_component'].includes('HR-R54')
    this.sideBarFlag['HR-R55'] = !this.erpUser['assigned_component'].includes('HR-R55')
    this.sideBarFlag['HR-R56'] = !this.erpUser['assigned_component'].includes('HR-R56')
    this.sideBarFlag['HR-R57'] = !this.erpUser['assigned_component'].includes('HR-R57')
    this.sideBarFlag['HR-R58'] = !this.erpUser['assigned_component'].includes('HR-R58')
    this.sideBarFlag['HR-R59'] = !this.erpUser['assigned_component'].includes('HR-R59')
    this.sideBarFlag['HR-R60'] = !this.erpUser['assigned_component'].includes('HR-R60')
    this.sideBarFlag['HR-R61'] = !this.erpUser['assigned_component'].includes('HR-R61')
    this.sideBarFlag['HR-R62'] = !this.erpUser['assigned_component'].includes('HR-R62')
    this.sideBarFlag['HR-R63'] = !this.erpUser['assigned_component'].includes('HR-R63')
    this.sideBarFlag['HR-R64'] = !this.erpUser['assigned_component'].includes('HR-R64')
    this.sideBarFlag['HR-R65'] = !this.erpUser['assigned_component'].includes('HR-R65')
    this.sideBarFlag['HR-R66'] = !this.erpUser['assigned_component'].includes('HR-R66')
    this.sideBarFlag['HR-R67'] = !this.erpUser['assigned_component'].includes('HR-R67')
    this.sideBarFlag['HR-R68'] = !this.erpUser['assigned_component'].includes('HR-R68')
    this.sideBarFlag['HR-R69'] = !this.erpUser['assigned_component'].includes('HR-R69')
    this.sideBarFlag['HR-R70'] = !this.erpUser['assigned_component'].includes('HR-R70')
    this.sideBarFlag['HR-R71'] = !this.erpUser['assigned_component'].includes('HR-R71')
    this.sideBarFlag['HR-R72'] = !this.erpUser['assigned_component'].includes('HR-R72')
    this.sideBarFlag['HR-R73'] = !this.erpUser['assigned_component'].includes('HR-R73')
    this.sideBarFlag['HR-R74'] = !this.erpUser['assigned_component'].includes('HR-R74')
    this.sideBarFlag['HR-R75'] = !this.erpUser['assigned_component'].includes('HR-R75')
    this.sideBarFlag['HR-R76'] = !this.erpUser['assigned_component'].includes('HR-R76')
    this.sideBarFlag['HR-R77'] = !this.erpUser['assigned_component'].includes('HR-R77')
    this.sideBarFlag['HR-R78'] = !this.erpUser['assigned_component'].includes('HR-R78')
    this.sideBarFlag['HR-R79'] = !this.erpUser['assigned_component'].includes('HR-R79')
    this.sideBarFlag['HR-R80'] = !this.erpUser['assigned_component'].includes('HR-R80')
    this.sideBarFlag['HR-R81'] = !this.erpUser['assigned_component'].includes('HR-R81')
    this.sideBarFlag['HR-R82'] = !this.erpUser['assigned_component'].includes('HR-R82')
    this.sideBarFlag['HR-R83'] = !this.erpUser['assigned_component'].includes('HR-R83')
    this.sideBarFlag['HR-R84'] = !this.erpUser['assigned_component'].includes('HR-R84')
    this.sideBarFlag['HR-R85'] = !this.erpUser['assigned_component'].includes('HR-R85')
    this.sideBarFlag['HR-R86'] = !this.erpUser['assigned_component'].includes('HR-R86')
    this.sideBarFlag['HR-R87'] = !this.erpUser['assigned_component'].includes('HR-R87')
    this.sideBarFlag['HR-R88'] = !this.erpUser['assigned_component'].includes('HR-R88')
    this.sideBarFlag['HR-R89'] = !this.erpUser['assigned_component'].includes('HR-R89')
    this.sideBarFlag['HR-R90'] = !this.erpUser['assigned_component'].includes('HR-R90')
    this.sideBarFlag['HR-R91'] = !this.erpUser['assigned_component'].includes('HR-R91')
    this.sideBarFlag['HR-R92'] = !this.erpUser['assigned_component'].includes('HR-R92')
    this.sideBarFlag['HR-R93'] = !this.erpUser['assigned_component'].includes('HR-R93')
    this.sideBarFlag['HR-R94'] = !this.erpUser['assigned_component'].includes('HR-R94')
    this.sideBarFlag['HR-R95'] = !this.erpUser['assigned_component'].includes('HR-R95')
    this.sideBarFlag['HR-R96'] = !this.erpUser['assigned_component'].includes('HR-R96')
    this.sideBarFlag['HR-R97'] = !this.erpUser['assigned_component'].includes('HR-R97')
    var component = this.erpUser['assigned_component'];
    for (let i = 0; i < component.length; i++) {

      if (component[i] == 'HR-R1') {
        this.dashborad_hidden = false
      }
      if (component[i] == 'HR-R2') {
        this.party_hidden = false
      }
      if (component[i] == 'HR-R3') {
        this.payroll_hidden = false
      }
      if (component[i] == 'HR-R4') {
        this.leave_hidden = false
      }
      if (component[i] == 'HR-R5') {
        this.report_hidden = false
      }
      if (component[i] == 'HR-R6') {
        this.HRAdministration_hidden = false
      }
      if (component[i] == 'HR-R7') {
        this.CodeValue_hidden = false
      }
      if (component[i] == 'HR-R8') {
        this.AddNewEmployee = false
      }
      if (component[i] == 'HR-R9') {
        this.setting_hidden = false
      }
      if (component[i] == 'HR-R10') {
        this.Field_hidden = false
      }
      if (component[i] == 'HR-R11') {
        this.CodeValue_hidden = false
      }
      if (component[i] == 'HR-R12') {
        this.LeaveRule_hidden = false
      }
      if (component[i] == 'HR-R13') {
        this.SalaryRule_hidden = false

      }
      if (component[i] == 'HR-R14') {
        this.PayMatrix_hidden = false
      }
      if (component[i] == 'HR-R15') {
        this.CityGroup_hidden = false
      }
      if (component[i] == 'HR-R16') {
        this.CCAMatrix_hidden = false
      }

      if (component[i] == 'HR-R17') {
        this.HRAMatrix_hidden = false
      }
      if (component[i] == 'HR-R18') {
        this.PBRMatrix_hidden = false
      }
      if (component[i] == 'HR-R19') {
        this.WFMATRIX_hidden = false
      }


      if (component[i] == 'HR-R20') {
        this.PayRule_hidden = false
      }
      if (component[i] == 'HR-R21') {
        this.Budget_hidden = false
      }
      if (component[i] == 'HR-R22') {
        this.Product_hidden = false
      }
      if (component[i] == 'HR-R23') {
        this.Activity_hidden = false
      }
      if (component[i] == 'HR-R24') {
        this.security_hidden = false
      }
      if (component[i] == 'HR-R25') {
        this.Role_hidden = false
      }
      if (component[i] == 'HR-R26') {
        this.Users_hidden = false
      }
      if (component[i] == 'HR-R27') {
        this.Hierarchy_hidden = false
      }
      if (component[i] == 'HR-R28') {
        this.DataAssingment_hidden = false
      }
      if (component[i] == 'HR-R29') {
        this.WorkFlow_hidden = false
      }
      if (component[i] == 'HR-R30') {
        this.AllData_hidden = false
      }
      if (component[i] == 'HR-R31') {
        this.AttendManagement_hidden = false
      }

      if (component[i] == 'HR-R32') {
        this.AttandanceRule_hidden = false
      }
      if (component[i] == 'HR-R33') {
        this.CalendarRule_hidden = false
      }

      if (component[i] == 'HR-R34') {
        this.BoundaryMap_hidden = false
      }
      if (component[i] == 'HR-R35') {
        this.ExtraWork_hidden = false
      }
      if (component[i] == 'HR-R36') {
        this.ExtraWorkPermission_hidden = false
      }
      if (component[i] == 'HR-R37') {
        this.LateSitting_hidden = false
      } if (component[i] == 'HR-R38') {
        this.ACR_hidden = false
      }

      if (component[i] == 'HR-R39') {
        this.AnnualConfidentialReport_hidden = false
      }
      if (component[i] == 'HR-R40') {
        this.Help_hidden = false
      }

      if (component[i] == 'HR-R41') {
        this.FAQ_hidden = false
      }
      if (component[i] == 'HR-R42') {
        this.UserManual_hidden = false
      }
      if (component[i] == 'HR-R43') {
        this.TutorialVideos_hidden = false
      }

      if (component[i] == 'HR-R44') {
        this.OnlineSupport_hidden = false
      } if (component[i] == 'HR-R45') {
        this.MyInfo_hidden = false
      }
      if (component[i] == 'HR-R46') {
        this.MarkAttendance_hidden = false
      }
      if (component[i] == 'HR-R47') {
        this.Notice_hidden = false
      }
      if (component[i] == 'HR-R48') {
        this.Employee_hidden = false

      }

      if (component[i] == 'HR-R49') {
        this.SalaryComponent_hidden = false

      }
      if (component[i] == 'HR-R50') {
        this.Bill_hidden = false
      }
      if (component[i] == 'HR-R51') {
        this.LPCTRANSFER_hidden = false
      }
      if (component[i] == 'HR-R52') {
        this.PaySlip_hidden = false
      }
      if (component[i] == 'HR-R53') {
        this.PensionCont_hidden = false
      }
      if (component[i] == 'HR-R54') {
        this.PFIT_hidden = false
      }
      if (component[i] == 'HR-R55') {
        this.SalaryHold_hidden = false
      }

      if (component[i] == 'HR-R56') {
        this.AnnualSalaryStatement_hidden = false
      }
      if (component[i] == 'HR-R57') {
        this.VariableAnnualSalaryStatement_hidden = false
      }
      if (component[i] == 'HR-R58') {
        this.AttendanceReport_hidden = false
      }
      if (component[i] == 'HR-R59') {
        this.List_hidden = false
      }

      if (component[i] == 'HR-R60') {
        this.AllEmployee_hidden = false
      }


      if (component[i] == 'HR-R61') {
        this.EducationInfo_hidden = false
      }
      if (component[i] == 'HR-R62') {
        this.NomineeInfo_hidden = false
      }

      if (component[i] == 'HR-R63') {
        this.BankDetail_hidden = false
      }
      if (component[i] == 'HR-R64') {
        this.LIC_hidden = false
      }

      if (component[i] == 'HR-R65') {
        this.DependentInfo_hidden = false
      }
      if (component[i] == 'HR-R66') {
        this.Establish_hidden = false
      }
      if (component[i] == 'HR-R67') {
        this.VariablePay_hidden = false
      }


      if (component[i] == 'HR-R68') {
        this.Posting_hidden = false
      }

      if (component[i] == 'HR-R69') {
        this.Promotion_hidden = false
      }
      if (component[i] == 'HR-R70') {
        this.Probation_hidden = false
      }
      if (component[i] == 'HR-R71') {
        this.Complaint_hidden = false
      }
      if (component[i] == 'HR-R72') {
        this.Enquiry_hidden = false
      }

      if (component[i] == 'HR-R73') {
        this.Suspension_hidden = false
      }
      if (component[i] == 'HR-R74') {
        this.Termination_hidden = false
      }

      if (component[i] == 'HR-R75') {
        this.Retirement_hidden = false
      }
      if (component[i] == 'HR-R76') {
        this.Death_hidden = false
      }

      if (component[i] == 'HR-R77') {
        this.Attandance_hidden = false
      }
      if (component[i] == 'HR-R78') {
        this.Leaves_hidden = false
      }
      if (component[i] == 'HR-R79') {
        this.LeaveApplication_hidden = false
      }
      if (component[i] == 'HR-R80') {
        this.LeaveList_hidden = false
      }
      if (component[i] == 'HR-R81') {
        this.TravelReimbursement_hidden = false
      }


      if (component[i] == 'HR-R82') {
        this.TourDetail_hidden = false
      }


      if (component[i] == 'HR-R83') {
        this.TABill_hidden = false
      }
      if (component[i] == 'HR-R84') {
        this.Arrear_hidden = false
      }

      if (component[i] == 'HR-R85') {
        this.SalaryBill_hidden = false
      }
      if (component[i] == 'HR-R86') {
        this.SalaryStartStop_hidden = false
      }
      if (component[i] == 'HR-R87') {
        this.AnnualIncrement_hidden = false
      }
      if (component[i] == 'HR-R88') {
        this.Advances_hidden = false
      }
      if (component[i] == 'HR-R89') {
        this.LeaveEncashment_hidden = false
      }
      if (component[i] == 'HR-R90') {
        this.Reappoaintment_hidden = false
      }
      if (component[i] == 'HR-R91') {
        this.Resign_hidden = false
      }
      if (component[i] == 'HR-R92') {
        this.Transfer_hidden = false
      }
      if (component[i] == 'HR-R93') {
        this.Reimbrusment_hidden = false
      }
      if (component[i] == 'HR-R94') {
        this.MedicalAdvance_hidden = false
      }
      if (component[i] == 'HR-R95') {
        this.TAReimbrusment_hidden = false
      }
      if (component[i] == 'HR-R96') {
        this.TAADV_hidden = false
      }
      if (component[i] == 'HR-R97') {
        this.BONUS_hidden = false
      }
    }

  }


  home() {
    this.router.navigate(['/index'])
  }

  refreshCol() {
    var col = document.getElementsByClassName('collapse')

    for (let i = 0; i <= col.length; i++) {
      if (col[i].classList.contains('show')) {
        col[i].classList.remove('show');
      }
    }

  }
  isDropdownOpen = false;

  placeholderText: any

  toggleSelect() {
    if (this.isDropdownOpen) {
      this.ngSelectElement.close();
    } else {
      this.ngSelectElement.open();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  selectedAction: any
  action = [
    { id: 1, name: 'Profile', route: "profile" },
    { id: 2, name: 'Logout', route: "login" },
  ];

  onSelectionChange2() {
    const selectedVal = this.selectedAction.route
    this.router.navigate([selectedVal]);
  }
}

